'use client';

import { useEffect, useState } from 'react';
import { MobileGuardProps } from './types';
import { Alert, Box, Center, darken, lighten, Text } from '@mantine/core';
import { IconInfoCircle } from '@tabler/icons-react';
import { palette } from '../../colors';
import { useTranslation } from 'react-i18next';
import { FONT_WEIGHT } from '../../fonts';

const getDeviceType = (): 'mobile' | 'desktop' =>
  window.screen.availWidth < 800 || window.screen.availHeight < 450
    ? 'mobile'
    : 'desktop';

export default function MobileGuard({ children }: MobileGuardProps) {
  const [state, setState] = useState<'loading' | 'mobile' | 'desktop'>(
    'loading',
  );
  const { t } = useTranslation();
  const textColor = lighten(palette.blackroomBlue, 0.4);

  const onResize = () => {
    setState(getDeviceType());
  };

  useEffect(() => {
    window.addEventListener('resize', onResize);
    onResize();
    return () => window.removeEventListener('resize', onResize);
  });

  return state === 'loading' ? null : state === 'mobile' ? (
    <Center w="100%" h="100%" bg="blackroomBlack">
      <Alert
        maw="90%"
        icon={<IconInfoCircle />}
        title={t('Common:errors.unavailableForSmallScreens')}
        bg={darken(palette.blackroomBlue, 0.66)}
        c={textColor}
      >
        <Text c={textColor} fw={FONT_WEIGHT.bold} fz="sm">
          {t('Common:errors.unavailableForSmallScreensSuggestion')}
        </Text>
      </Alert>
    </Center>
  ) : (
    <Box style={{ width: 'inherits', height: 'inherits' }}>{children}</Box>
  );
}
